<template>
  <div>
    <loader></loader>
    <no-habilitado v-if="!habilitado" perfil="Arkidians"></no-habilitado>
    <section id="login">
      <div style="margin-top:80px; margin-bottom:50px">
        <div class="container h-100 d-flex justify-content-center">
          <div class="login my-auto">
            <router-link
              v-if="$routerHistory.hasPrevious()"
              :to="{ path: $routerHistory.previous().path }"
              tag="button"
              class="close"
            >x</router-link>

            <form style="padding:10px; margin:10px">
              <h3 style="text-align:center; padding-bottom:15px">Nuevo Arkidian</h3>
              <div class="form-group">
                <label>Sobrenombre</label>
                <input class="form-control" v-model="newArkidian.nickname" />
              </div>
              <div class="form-group">
                <label for="example-datepicker">Fecha de nacimiento</label>
                <b-form-datepicker
                  id="example-datepicker"
                  placeholder="Con esta fecha podremos sugerir mejores actividades en función a su edad"
                  v-model="newArkidian.fechaNacimiento"
                  class="mb-2"
                  no-flip
                ></b-form-datepicker>
              </div>


              <h5 style="padding-top:20px">Datos de acceso</h5>
              <p>Tu arkidian va a acceder con este usuario y contraseña</p>
              <div class="form-group">
                <label>Usuario</label>
                <input class="form-control" v-model="newArkidian.usuario" />
              </div>
              <div class="form-group">
                <label>Contraseña</label>
                <b-form-input type="text" v-model="newArkidian.password"></b-form-input>
              </div>
              <div v-if="errorMessage" class="alert alert-danger" role="alert">{{errorMessage}}</div>
              <div v-if="successMessage" class="alert alert-success" role="alert">{{successMessage}}</div>
              <div style="text-align:center">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="altaArkidian(newArkidian)"
                >Crear Arkidian</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NoHabilitado from "../shared/NoHabilitado";
import Loader from "../shared/Loader";

export default {
  name: "app",
  computed: {
    ...mapGetters(["pathAPI", "userLogged", "categorias", "cursoSeleccionado"])
  },
  data() {
    return {
      habilitado: false,
      newArkidian: {
        nickname: "",
        fechaNacimiento: "",
        usuario: "",
        password: "",
        avatar: ""
      },
      avatars: [
        { imagen: "images/arkidians/ark1.svg", selected: false },
        { imagen: "images/arkidians/ark2.svg", selected: false },
        { imagen: "images/arkidians/ark3.svg", selected: false },
        { imagen: "images/arkidians/ark4.svg", selected: false },
        { imagen: "images/arkidians/ark5.svg", selected: false },
        { imagen: "images/arkidians/ark6.svg", selected: false },
        { imagen: "images/arkidians/ark7.svg", selected: false },
        { imagen: "images/arkidians/ark8.svg", selected: false },
        { imagen: "images/arkidians/ark9.svg", selected: false },
        { imagen: "images/arkidians/ark10.svg", selected: false },
        { imagen: "images/arkidians/ark11.svg", selected: false },
        { imagen: "images/arkidians/ark12.svg", selected: false }
      ],

      selected: null,
      options: [],

      errorMessage: "",
      successMessage: ""
    };
  },

  methods: {
    altaArkidian(arkidian) {
      var self = this;
      self.errorMessage = "";
      self.successMessage = "";
      arkidian.avatar = "images/arkidians/profile.svg"

      var bodyApi = "";

      bodyApi =
        "usuario=" +
        arkidian.usuario +
        "&alias=" +
        arkidian.nickname +
        "&usuario_padre=" +
        this.userLogged.user +
        "&fecha=" +
        arkidian.fechaNacimiento +
        "&password=" +
        arkidian.password +
        "&avatar=" +
        arkidian.avatar;

      fetch(this.pathAPI + "hijos.php", {
        method: "POST",
        body: bodyApi,
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      }).then(function(response) {
        if (response.ok) {
          var respuesta = response.json();
          respuesta.then(function(result) {
            if (result.resultado == "ERROR") {
              self.errorMessage = result.mensaje;
            } else {
              self.successMessage = "Arkidian dado de alta";
              self.$router.push({ path: "/Arkidians" });
            }
          });
        } else {
          self.errorMessage = "Hay un error, verificá los datos ingresados";
        }
      });
    },

    volver() {
      this.$router.push({ path: "/Arkidians" });
    }
  },

  components: {
    Loader: Loader,
    NoHabilitado: NoHabilitado
  },

  mounted: function() {
    if (this.userLogged.profile == "PADRE") {
      this.habilitado = true;
      const loader = document.querySelector(".loader");
      loader.className += " hidden";
    }
  }
};
</script>

<style scoped>
#login {
  background: url("/public/images/site/background-modal-admin.svg");
  background-repeat: repeat-x;
  background-size: 1000px;
  display: table;
  width: 100%;
  background-position-y: top;
}
.login {
  width: 90%;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  background-color: #e9ecef;
  border-radius: 15px;
  -webkit-box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
  box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
}
.close {
  padding: 0px;
  font-size: 40px;
  font-weight: 300;
}
.label {
  margin-bottom: 0px;
}
.dropdown-menu.show {
  margin-top: 30px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/sections/NewArkidian.vue